import React from 'react';
import { ReactComponent as Info } from 'assets/icons/icon-right-title.svg';
import { twMerge } from 'tailwind-merge';

type FieldDescribeProps = {
  className?: string;
  maxLength: number;
  currentLength: number;
};

const InputLength = ({
  className,
  maxLength,
  currentLength,
}: FieldDescribeProps) => {
  return (
    <p
      className={twMerge(
        'text-med-gray-3 font-semibold text-xs flex flex-row items-center gap-0.5',
        className,
      )}
    >
      <Info className="flex-shrink-0 w-4 h-4" />
      <span>
        {currentLength}/{maxLength}
      </span>
    </p>
  );
};

export default InputLength;
